import { ApiError } from '@gorila-shared-ui/components';
import { ApiEndpoint } from '../types/api';
import { NotificationType } from '../types/notifications';
import { getRequest } from './api';
import { URLS } from './urls/urls';

export const getNotificationTypes = async (): Promise<{
  notificationTypes?: NotificationType[];
  error?: ApiError;
  total?: number;
}> => {
  const response = await getRequest(
    URLS.notification.types.all,
    {
      queryParams: {
        exclude_autoreport: false,
      },
    },
    ApiEndpoint.core,
  );

  return {
    notificationTypes: response?.data,
    error: response?.error,
  };
};
